/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AlertTypeEnum {
    GENERIC = 'Generic',
    DELINQUENT = 'Delinquent',
    DOOR_TAG = 'DoorTag',
    CUTOFF = 'Cutoff',
    COLLECTION_LIST = 'CollectionList',
    BANKRUPTCY = 'Bankruptcy',
    WRITE_OFF = 'WriteOff',
    GLOBAL = 'Global',
}